import { MTableEditField } from '@material-table/core';
import { lcsInternalExposureLookup, lcsNames, M_ID } from 'utils/constants/lcsTypes';
import React from 'react';

export default (user, flowsLookup) => {
  const columns = [
    {
      title: 'Código',
      field: 'code',
      minWidth: 150,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Fluxograma',
      field: 'flow_id',
      lookup: flowsLookup,
      initialEditValue: Object.keys(flowsLookup)[0],
      minWidth: 400,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      editComponent: (props) => <MTableEditField fullWidth {...props}/>,
    },
    {
      title: 'LCS',
      field: 'lcs_id',
      minWidth: 200,
      initialEditValue: M_ID,
      lookup: lcsInternalExposureLookup,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      render: rowData => rowData.lcs_id !== '' ? lcsInternalExposureLookup[rowData.lcs_id] : '',
    },
    {
      title: 'Designação',
      field: 'designation',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Notas',
      field: 'notes',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
